var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"lv-icon",class:[_vm.icon, _vm.color],style:({
    'font-size': `${_vm.size}`,
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }